import { importFileModalReducerKey } from './ImportFileModalConstants';

export const importFileModal = (state) => {
  return state.get(importFileModalReducerKey);
};

export const isLoading = (state) => {
  return importFileModal(state).get('isLoading');
};

export const isClosed = (state) => {
  return importFileModal(state).get('isClosed');
};

export const uploadedFile = (state) => {
  return importFileModal(state).get('uploadedFile');
};
